import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import { CustomDropDown, CustomInput, CustomInputTextArea, CustomNumberInput2 } from "../components/AllInputs";
import PrimaryButton, { OutlinedButton } from "../components/CustomButtons";
import { useDispatch, useSelector } from "react-redux";
import { showFormErrors } from "../../utils/commonFunctions";
import { submitEnquiry } from "../../store/slices/enquirySlice";
import formValidation from "../../utils/validations";
import { useParams } from "react-router-dom";
import { fetchServices } from "../../store/slices/servicesSlice";

const EnquiryModal = ({ visible, setVisible }) => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const { isLoading } = useSelector((state) => state?.loader);
    const { services } = useSelector((state) => state.service);
    const [data, setData] = useState({
        fullName: "",
        email: "",
        phoneNumber: "",
        serviceId: "",
        propertyType: "",
        message: "",
        files: [],
    });
    const [selectedFiles, setSelectedFiles] = useState([]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (showFormErrors(data, setData)) {
            dispatch(submitEnquiry({ data, resetForm }));
        }
    };

    const handleChange = ({ name, value }) => {
        const formErrors = formValidation(name, value, data);
        setData((prev) => ({ ...prev, [name]: value, formErrors }));
    };

    const handleFileSelect = (e) => {
        const files = Array.from(e.target.files);
        setSelectedFiles(files);
        setData((prev) => ({ ...prev, files }));
    };

    const resetForm = () => {
        setData({
            fullName: "",
            email: "",
            phoneNumber: null,
            serviceId: id || "",
            propertyType: "",
            message: "",
            files: [],
        });
        setSelectedFiles([]);
        setVisible(false)
    };

    useEffect(() => {
        if (id) {
            dispatch(fetchServices());
        }
    }, [id, dispatch]);

    return (
        <Dialog
            header=""
            visible={visible}
            onHide={() => {
                setVisible(false)
                resetForm()
            }}
            style={{ width: "50vw" }}
            draggable={false}
            resizable={false}
            breakpoints={{ "960px": "75vw", "641px": "100vw" }}
        >
            <div className="bg-white border-round-xl">
                <h2 className="heading text-5xl mt-0 text-center font-semibold">
                    Drop your query to connect with experts
                </h2>
                <form onSubmit={handleSubmit}>
                    <div className="grid m-0">
                        <CustomInput
                            label="Name"
                            col={6}
                            extraClassName="px-2 mb-4"
                            name="fullName"
                            data={data}
                            onChange={handleChange}
                            required
                        />
                        <CustomInput
                            label="Email Address"
                            col={6}
                            extraClassName="px-2 mb-4"
                            name="email"
                            data={data}
                            onChange={handleChange}
                            type="email"
                            required
                        />
                        <CustomNumberInput2
                            label="Phone number"
                            col={6}
                            extraClassName="px-2 mb-4"
                            name="phoneNumber"
                            placeholder="Phone Number"
                            data={data}
                            onChange={handleChange}
                            required
                            maxLength={15}
                        />
                        <CustomDropDown
                            label="Choose the service for quotation"
                            col={6}
                            extraClassName="px-2 mb-4"
                            name="serviceId"
                            data={data}
                            onChange={handleChange}
                            options={services}
                            optionLabel="serviceName"
                            required
                        />
                        <CustomInput
                            label="Property Type"
                            col={6}
                            extraClassName="px-2 mb-4"
                            name="propertyType"
                            data={data}
                            onChange={handleChange}
                            required
                        />
                        <CustomInputTextArea
                            label="Write your message here along with photos, link (if available)"
                            col={12}
                            extraClassName="px-2 mb-4"
                            name="message"
                            data={data}
                            onChange={handleChange}
                            required
                            rows={5}
                        />
                        <div className="flex col-12 gap-3 align-items-center">
                            <p>Add file</p>
                            <input
                                type="file"
                                id="file-upload"
                                multiple
                                onChange={handleFileSelect}
                                style={{ display: "none" }}
                                accept=".jpeg, .jpg, .png"
                            />
                            <OutlinedButton
                                type="button"
                                label={
                                    selectedFiles.length > 0
                                        ? `${selectedFiles.length} file(s) selected`
                                        : "Upload floorplan/Files"
                                }
                                icon="pi pi-upload"
                                extraClassNames="w-auto"
                                onClick={() => document.getElementById("file-upload").click()}
                            />
                        </div>
                        {selectedFiles.length > 0 && (
                            <div className="col-12 mt-2">
                                <p className="font-medium">Selected files:</p>
                                <ul className="p-0 m-0 list-none">
                                    {selectedFiles.map((file, index) => (
                                        <li key={index} className="flex align-items-center gap-2">
                                            <i className="pi pi-file text-sm"></i>
                                            <span className="text-sm">{file.name}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                    <PrimaryButton
                        label={isLoading ? "Submitting..." : "Submit"}
                        extraClassNames="mx-auto w-auto px-7 block mt-5"
                        type="submit"
                        disabled={isLoading}
                    />
                </form>
            </div>
        </Dialog>
    )
}

export default EnquiryModal